import { useIntl } from 'react-intl';

import FullscreenBackground from '@/components/image/FullscreenBackground';
import Loader from '@/components/Loader';
import { useCoupon } from '@/hooks/purchase';
import { useAppLoadedState, usePurchaseParamsState } from '@/hooks/store';

import messages from './messages';
import {
	BulletPoint,
	BulletPoints,
	CheckIcon,
	Container,
	CountdownContainer,
	Heading,
	Icon,
	Subheading,
	Wrapper,
} from './styles';
import { UpsellProps } from './types';

const Upsell = ({ bgImg }: UpsellProps) => {
	const { formatMessage } = useIntl();
	const { discount: percentOff } = useCoupon();
	const appLoaded = useAppLoadedState();
	const { plan } = usePurchaseParamsState();

	return (
		<Wrapper>
			<FullscreenBackground src={bgImg} objectPosition="top" />
			{appLoaded ? (
				<Container>
					<Icon src="/_n/images/calm-logo-square.png" alt="Calm Icon" />
					{percentOff && (
						<Heading>
							{formatMessage(messages.percentOff, {
								percentOff: Math.round(percentOff),
							})}
						</Heading>
					)}
					<Subheading>
						{plan === 'lifetime' && formatMessage(messages.lifetimePriceTitle)}
						{plan === 'yearly' && formatMessage(messages.yearlyPriceTitle)}
					</Subheading>
					<CountdownContainer>
						<BulletPoints>
							{plan === 'lifetime' ? (
								<>
									<BulletPoint>
										<CheckIcon />
										{formatMessage(messages.lifetimeUnlimited)}
									</BulletPoint>
									<BulletPoint>
										<CheckIcon />
										{formatMessage(messages.lifetimeImproveSleep)}
									</BulletPoint>
									<BulletPoint>
										<CheckIcon />
										{formatMessage(messages.lifetimeLimitedTime)}
									</BulletPoint>
								</>
							) : (
								<>
									<BulletPoint>
										<CheckIcon />
										{formatMessage(messages.learnLifeChanging)}
									</BulletPoint>
									<BulletPoint>
										<CheckIcon />
										{formatMessage(messages.fallIntoDeepSleep)}
									</BulletPoint>
									<BulletPoint>
										<CheckIcon />
										{formatMessage(messages.musicTracksForFocus)}
									</BulletPoint>
								</>
							)}
						</BulletPoints>
					</CountdownContainer>
				</Container>
			) : (
				<Loader />
			)}
		</Wrapper>
	);
};

export default Upsell;
